import React, { PropTypes } from 'react';

const SegmentLoader = ({ heigth = '180px' }) => (
  <div className="ui loading segment" style={{ minHeight: heigth }} />
);

SegmentLoader.propTypes = {
  heigth: PropTypes.string,
};

export default SegmentLoader;



// WEBPACK FOOTER //
// ./src/modules/common/components/SegmentLoader.js